(ns frontend.view.components.timeline.entry.oppo-move
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.db :as db]
            [common.localization :as loc]
            [frontend.state.current-session :as session]
            [frontend.utils :as fu]))

(defmethod te/timeline-entry-view :op.oppo/move [{entry :entry}]
  (let [title-generator (fn [entry]
                          (let [oppo-name (->> entry
                                               :audit/target
                                               (get @session/entities)
                                               :oppo/name)]
                            (-> entry
                                :audit/op
                                loc/tr
                                (fu/format oppo-name))))
        body-generator (fn [entry]
                         (if-let [stage (-> entry :audit/target-changes :oppo/stage)]
                           (let [old-stage (-> stage :unset :stage/name)
                                 new-stage (-> stage :set :stage/name)]
                             [:p (loc/tr :timeline.oppo/move-from)
                              [:span.strong.black old-stage]
                              (loc/tr :timeline.oppo/move-to)
                              [:span.strong.blue new-stage]])
                           (let [ord (-> entry :audit/target-changes :common/ord)
                                 direction (if (> (:set ord) (:unset ord))
                                             (loc/tr :timeline.oppo.move/down)
                                             (loc/tr :timeline.oppo.move/up))]
                             [:p (loc/tr :timeline.oppo/moved-direction)
                              [:span.strong.blue direction]])))]

    ; TODO : Arrows can be added to display the direction of the move
    [default/timeline-item-view entry title-generator body-generator default/timestamp-generator]))
